export enum EObjectStore {
  POLL = 'POLL',
  UNIT = 'UNIT',
  ANSWERS = 'ANSWERS',
  FAILEDANSWERS = 'FAILEDANSWERS',
  RESPONSESSENT = 'RESPONSESSENT',
  INCENTIVE = 'INCENTIVE',
}
